module.exports = __webpack_public_path__ + "static/media/s3-bottom-left-6.e5fee20f.png";